module.exports = "/images/vendor/flag-icon-css/flags/1x1/sj.svg?ecbc9e939c3823f82f4ffa804f7d4dd4";